// pages/Videos.js
import React, { useEffect, useState } from 'react';
import '../styles/VideoSection1.css';
import Carousel from '../components/Carousel';


function VideosAMZ() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [filter, setFilter] = useState('all');
  const [selectedVideo, setSelectedVideo] = useState(null);

  const videos = [
{ id: 1, title: 'ⵜⵓⴳⴳⴰ ⵏ ⵜⵓⵏⴳⵉⵙⵜ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ', description: 'ⵜⴰⵍⵍⴰⵙⵜ ⵜⴰⵏⵉⵍⴰⵡⵜ ⵏ ⵢⴰⵜ ⵜⵎⵖⴰⵔⵜ ⵉⵎⵏⴰⵍⴰⵏ ⵜⴰⴷⴱⵔⵜ ⵜⴰⵍⵉⴽⵟⵕⵓⵏⵉⵜ ⴷ ⵎⴰⵎⴽ ⵙ ⵜⵣⵔⵉ ⵜⴰⵙⵙⴰⵙⵜ ⵏⵏⵙ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ',   youtubeId: 'dQw4w9WgXcQ' },
{ id: 2, title: 'ⴰⵥⵍⵍⴻⵍ ⴳ ⵉⵙⵉⵜⵏ ⵏ ⵓⵎⵢⴰⵡⴰⴹ', description: 'ⵜⴰⵄⵔⵔⵉⵎⵜ ⵉⵜⵜⴰⵍⵙⵏ ⵜⵉⵔⵎⵉⵜ ⵏⵏⵙ ⵅⴼ ⵓⵣⵓⵅⵅⵓ ⴰⵍⵉⴽⵟⵕⵓⵏⵉ ⴷ ⵓⴹⵉⵚ ⵏⵏⵙ ⵅⴼ ⵜⵓⴷⵔⵜ ⵏⵏⵙ ⵜⴰⴽⵓⵢⴰⵙⵙⵜ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⴰⵥⵍⵍⴻⵍ ⴰⵎⵓⵟⵟⵓⵏ' ,   youtubeId: 'dQw4w9WgXcQ' },
{ id: 3, title: 'ⵜⵉⵖⴰⵡⵜ ⵜⴰⵍⵉⴽⵟⵕⵓⵏⵉⵜ', description: 'ⵎⴰⵎⵏⴽ ⵙ ⵉⵜⵜⵓⵙⵏⴼⵍ ⵓⵣⴷⴰⵢ ⴰⵏⴰⴼⵔⴰⵏ ⵙ ⴱⴰⵖⵔⴰⵔ ⴰⵎⵓⵟⵟⵓⵏ ⴷ ⵉⴱⵔⴷⴰⵏ ⵏ ⵓⴼⵔⴰⴳ ⵓⵍⴳⵉⵏ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⵜⴰⴷⴱⵔⵜ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 4, title: 'ⴰⵙⵃⵍⵍⴻⵍ ⵉⵖⴱⴰⵏ ⴷ ⵜⵖⵉⵙⵜ ⵜⵉⵎⵍⵥⵉⵜ', description: 'ⵜⵓⵏⴳⵉⵙⵜ ⵏ ⵜⴻⵜⵉⵇⵏⵉⵜ ⵏ ⵓⵙⵃⴻⵍⵍⴻⵍ ⵉⵖⴱⴰⵏ "Deepfake", ⵜⴱⴹⴰ ⴰⵙⵏⵜⵔ ⵏⵏⵙ ⴰⴽⴷ ⵜⵡⵍⴰⴼⵉⵏ ⵉⵜⵜⵓⵙⴽⴰⵔⵏ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⴰⴼⵔⴰⴳ ⵏ ⵜⵓⵙⵍⵉⴳⵜ' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 5, title: 'ⴰⴹⴼⴼⵓⵕ ⴰⵍⵉⴽⵟⵕⵓⵏⵉ', description: 'ⵜⴰⵎⵖⴰⵔⵜ ⵉⵎⵏⴰⵍⴰⵏ ⴰⴹⴼⴼⵓⵕ ⴰⵙⵓⵍⴰⵏ ⵏ ⴽⵔⴰ ⵏ ⵓⴳⴳⵉⴷ ⵓⵔ ⵉⵜⵜⵡⴰⵙⵙⴰⵏⵏ ⴳ ⵡⴰⵏⵜⵉⵔⵏⵉⵜ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⵜⴰⵏⴼⵔⵓⵜ ⵏ ⵡⴰⵏⵜⵉⵔⵏⵉⵜ' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 6, title: 'ⴰⵣⵓⵣⵣⵔ ⵏ ⵜⵡⵍⴰⴼⵉⵏ ⴱⵍⴰ ⵜⵓⵔⴰⴳⵜ', description: 'ⵜⵉⵔⵎⵉⵜ ⵉⵛⵇⵇⴰⵏ ⴽⵓⴷⵏⵏⴰ ⵜⵜⵓⵣⵓⵣⵣⵔⵏⵜ ⵜⵡⵍⴰⴼⵉⵏ ⵜⵓⵙⵍⵉⴳⵉⵏ ⴷ ⵜⵎⴰⵎⴽⵜ ⵏ ⵓⵙⵡⵔⵔⵉ ⵏ ⵡⴰⴷⴷⵓⵔ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⴰⴼⵔⴰⴳ ⵏ ⵜⵓⵙⵍⵉⴳⵜ' ,   youtubeId: 'dQw4w9WgXcQ' },
{ id: 7, title: 'ⴰⵡⵏⵏⵉ ⵏ ⵓⴽⵙⴰⵏ ⵉⵜⵜⵓⵙⵡⴰⵍⴰⵏ', description: 'ⵜⴰⵎⵖⵏⴰⵙⵜ ⵉⵎⵏⴰⵍⴰⵏ ⵉⵎⵣⵉⵣⵣⵍⵏ ⵉⵏⵎⴰⵍⴰⵏ ⵏ ⵓⴽⵙⴰⵏ ⴷ ⵓⵙⵉⵙⵙⵏ ⴳ ⵡⴰⵏⵜⵉⵔⵏⵉⵜ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⴰⵙⵉⵎⵎⵕ ⵅⴰⴼ ⵜⴽⵕⴹⵉ' ,   youtubeId: 'dQw4w9WgXcQ' },
{ id: 8, title: 'ⵜⴰⴷⴱⵔⵜ ⵜⴰⵥⵕⴼⴰⵏⵜ ⵜⴰⵍⵉⴽⵟⵕⵓⵏⵉⵜ', description: 'ⵜⴰⵄⵔⵔⵉⵎⵜ ⵉⵎⵏⴰⵍⴰⵏ ⵜⴰⴷⴱⵔⵜ ⵜⴰⵥⵕⴼⴰⵏⵜ ⴷⴼⴼⵉⵔ ⴰⴷⴰⴼ ⴰⵔⵓⵍⴳⵉⵏ ⵖⵔ ⵉⵎⵉⴹⴰⵏⵏ ⵏⵏⵙ ⵉⵏⵉⵎⴰⵏⵏ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⵜⴰⴷⴱⵔⵜ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 9, title: 'ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⴳ ⵜⵡⵓⵔⵉ', description: 'ⵜⴰⵎⵙⵖⴰⵏⵜ ⵉⵜⵜⵎⵏⴰⵍⴰⵏ ⴰⵥⵍⵍⴻⵍ ⴰⵙⵓⵍⴰⵏ ⴳ ⵜⴷⴰⴱⵓⵜⵉⵏ ⵏ ⵓⵎⵢⴰⵡⴰⴹ ⴰⵣⵣⵓⵍⴰⵏ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⴰⵥⵍⵍⴻⵍ ⴰⵎⵓⵟⵟⵓⵏ' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 10, title: 'ⴰⵔⵛⴰⴳ ⵏ ⵉⵎⵉⴹⴰⵏⵏ ⵉⵏⵉⵎⴰⵏⵏ', description: 'ⵜⴰⵍⵍⴰⵙⵜ ⵏ ⵓⵔⵛⴰⴳ ⵏ ⵓⵎⵉⴹⴰⵏ ⵏ ⴼⵉⵢⵙⴱⵓⴽ ⴷ ⵓⵙⵎⵔⵙ ⵏⵏⵙ ⴳ ⵓⵙⵉⵙⵙⵏ ⴷ ⵓⵣⵍⵍⵣⴷⵉ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⵜⴰⵏⴼⵔⵓⵜ ⵏ ⵡⴰⵏⵜⵉⵔⵏⵉⵜ' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 11, title: 'ⴰⵣⵓⵅⵅⵓ ⴳ ⵜⵏⵖⵎⴰⵙⵜ', description: 'ⵜⴰⵏⵖⵎⴰⵙⵜ ⵉⵎⵏⴰⵍⴰⵏ ⵉⵎⵣⵉⵣⵣⵍⵏ ⵏ ⵓⵣⵓⵅⵅⵓ ⵙ ⵜⵎⵏⵜⵉⵍⵜ ⵏ ⵓⵙⴷⵍ ⵏⵏⵙ ⵉ ⵜⵎⵙⴰⵔⵉⵏ ⵜⵉⵡⵜⵎⴰⵏⵉⵏ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⴰⵙⵉⵎⵎⵕ ⵅⴰⴼ ⵜⴽⵕⴹⵉ' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 12, title: 'ⵜⴰⴷⴱⵔⵜ ⵜⴰⵡⵙⵢⴰⵏⵜ ⴳ ⵡⴰⵏⵜⵉⵔⵏⵉⵜ', description: 'ⵜⴰⵔⴱⴰⵜ ⵜⵓⵎⵥⵉⵢⵜ ⵉⵎⵏⴰⵍⴰⵏ ⴰⵙⵖⵍⵍⴰ ⴰⵡⵙⵢⴰⵏ ⴳ ⵜⴷⴰⴱⵓⵜⵉⵏ ⵏ ⵡⵓⵔⴰⵔⵏ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⵜⴰⴷⴱⵔⵜ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ' ,  youtubeId: 'dQw4w9WgXcQ' },
{ id: 13, title: 'ⴰⵙⴽⴰⵔ ⵏ ⵉⵎⵉⴹⴰⵏⵏ ⵏ ⵓⵙⵃⵍⵍⴻⵍ', description: 'ⵜⴰⵎⵖⴰⵔⵜ ⵏⵏ ⵢⵓⴼⴰⵏ ⵎⵏⵏⴰⵡ ⵏ ⵉⵎⵉⴹⴰⵏⵏ ⵏ ⵓⵙⵃⵍⵍⴻⵍ ⵙ ⵢⵉⵙⵎ ⵏⵏⵙ ⵜⵣⵓⵣⵣⵓⵔ ⵜⵓⵎⴰⵢⵜ ⵉⵅⵛⵏⵏ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⴰⴼⵔⴰⴳ ⵏ ⵜⵓⵙⵍⵉⴳⵜ' ,  youtubeId: 'dQw4w9WgXcQ' },
{ id: 14, title: 'ⴰⵙⴷⵉⴷⴷⵉ ⵙ ⵜⵎⵏⵖⵉⵡⵜ ⴳ ⵡⴰⵏⵜⵉⵔⵏⵉⵜ', description: 'ⵜⴰⵎⵖⵏⴰⵙⵜ ⵜⴰⵣⵔⴼⴰⵏⵜ ⵉⵜⵜⵓⵙⴷⵉⴷⴷⵉⵢⵏ ⵙ ⵜⵎⵏⵖⵉⵡⵜ ⴽⵓ ⴰⵙⵙ ⴳ ⵉⵙⵉⵜⵏ ⵏ ⵓⵎⵢⴰⵡⴰⴹ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵉⵙⵙⵉⵡⵉⴹⵏ ⵖⵔ ⵜⵏⵖⵉⵎⴰⵏⵜ' ,  youtubeId: 'dQw4w9WgXcQ'},
{ id: 15, title: 'ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵜⴰⵡⵊⴰⵡⴰⵏⵜ', description: 'ⴰⵔⴳⴰⵣ ⵉⵙⵙⵎⵔⴰⵙⵏ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ ⵉ ⵓⵏⴱⴰⴹ ⴷ ⵓⴹⴼⴼⵓⵕ ⵏ ⵜⵎⵖⴰⵔⵜ ⵏⵏⵙ ⵙ ⵜⵡⵉⵍⴰ ⵜⴰⵙⵓⵍⴰⵏⵜ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ' ,  youtubeId: 'dQw4w9WgXcQ' },
{ id: 16, title: 'ⵜⴰⵍⵍⴰⵙⵜ ⵏ ⵓⵏⵊⴰⵎ ⴷ ⵓⵙⵉⵔⵎ', description: 'ⵜⵓⵏⵊⵉⵎⵜ ⵙⴳ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵜⴱⴹⴰ ⴰⵎⵓⴷⴷⵓ ⵏ ⵜⴷⵓⵙⵉ ⴷ ⵓⵖⵓⵍ ⵖⵔ ⵜⵓⴷⵔⵜ ⵜⴰⴳⴰⵎⴰⵏⵜ', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ' ,  youtubeId: 'dQw4w9WgXcQ' }
  ];

  const categories = [
    'all',
    'ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵉⵙⵙⵉⵡⵉⴹⵏ ⵖⵔ ⵜⵏⵖⵉⵎⴰⵏⵜ',
    'ⵜⴰⴷⴱⵔⵜ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ',
    'ⴰⴼⵔⴰⴳ ⵏ ⵜⵓⵙⵍⵉⴳⵜ',
    'ⵜⴰⵏⴼⵔⵓⵜ ⵏ ⵡⴰⵏⵜⵉⵔⵏⵉⵜ',
    'ⴰⵥⵍⵍⴻⵍ ⴰⵎⵓⵟⵟⵓⵏ',
    'ⴰⵙⵉⵎⵎⵕ ⵅⴰⴼ ⵜⴽⵕⴹⵉ',
    'ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ'
  ];

  const filteredVideos = filter === 'all'
    ? videos
    : videos.filter(video => video.category === filter);

  // Fonctions pour le modal
  const openVideoModal = (video) => {
    setSelectedVideo(video);
    document.body.style.overflow = 'hidden';
  };

  const closeVideoModal = () => {
    setSelectedVideo(null);
    document.body.style.overflow = 'unset';
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') closeVideoModal();
    };

    if (selectedVideo) {
      window.addEventListener('keydown', handleEscape);
    }
    return () => window.removeEventListener('keydown', handleEscape);
  }, [selectedVideo]);

  return (
    <div className="videos-page" style={{ direction: 'ltr' }}>
      {/* Hero Section */}
      <div style={{
        padding: '80px 0 40px',
        textAlign: 'center',
        backgroundImage: 'url(/images/cover.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        width: '100%',
        marginLeft: 'calc(-50vw + 50%)',
        minHeight: '400px'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1
        }}></div>
        <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>
          <img
            src="/images/Asset6.png"
            alt="Videos Icon"
            style={{ width: '80px', height: '80px', objectFit: 'contain' }}
          />
          <h1 style={{
            fontSize: '3.5rem',
            marginBottom: '20px',
            background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
          ⵜⵓⴳⴳⴰ
          </h1>
          <p style={{ fontSize: '1.3rem', color: 'var(--text-light)', maxWidth: '700px', margin: '0 auto' }}>
ⵜⵓⴳⴳⴰ ⴷ ⵉⵜⵜⵢⴰⴳⴰⵎⵏ ⵙⴳ ⵜⴰⵍⵍⴰⵙⵉⵏ ⵜⵉⵎⵢⴰⴳⴰⵏⵉⵏ ⴷ ⵜⴰⵍⵍⴰⵙⵉⵏ ⵉⵜⵜⵡⴰⴹⴼⴰⵕⵏ ⴳ ⵓⵙⴰⵢⵔⴰⵔ ⴰⵎⵓⵟⵟⵓⵏ. ⵉⵙⵎⴰⵡⵏ ⵓⵔ ⴳⵉⵏⵉⵏ ⵉⵏⵉⵍⴰⵡⵏ
            </p>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0' }}>
        <div className="container">
          {/* Filter Section */}
          <div style={{ marginBottom: '50px', textAlign: 'center' }}>
            <h3 style={{ fontSize: '1.8rem', marginBottom: '25px', color: 'var(--white)' }}>
              ⵙ ⵢⵉⵙⵎⵉⵍ
            </h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px' }}>
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setFilter(category)}
                  style={{
                    padding: '12px 30px',
                    borderRadius: '25px',
                    border: filter === category ? '2px solid var(--primary-orange)' : '2px solid rgba(255, 107, 53, 0.3)',
                    background: filter === category ? 'var(--primary-orange)' : 'var(--primary-black)',
                    color: 'var(--white)',
                    fontSize: '1.1rem',
                    fontWeight: filter === category ? '700' : '500',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    fontFamily: 'Noto Sans Tifinagh, sans-serif'
                  }}
                  onMouseEnter={(e) => {
                    if (filter !== category) {
                      e.target.style.borderColor = 'var(--primary-orange)';
                      e.target.style.background = 'rgba(255, 107, 53, 0.1)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (filter !== category) {
                      e.target.style.borderColor = 'rgba(255, 107, 53, 0.3)';
                      e.target.style.background = 'var(--primary-black)';
                    }
                  }}
                >
                  {category === 'all' ? 'ⴽⵓⵍⵍⵓ' : category}
                </button>
              ))}
            </div>
            <p style={{ marginTop: '20px', fontSize: '1.1rem', color: 'var(--text-light)' }}>
              ⴰⵙⵎⴰⵍ ⵏ {filteredVideos.length} ⵙⴳ {videos.length} ⵜⵓⴳⴳⴰ
            </p>
          </div>

          {/* Videos Grid avec modal */}
          <div className="video-grid">
            {filteredVideos.map((video) => (
              <div key={video.id} className="video-card">
                <div
                  className="video-thumbnail"
                  onClick={() => openVideoModal(video)}
                >
                  <img src={video.thumbnail} alt={video.title} />
                  <div className="play-button"></div>
                </div>
                <div className="video-info" style={{ textAlign: 'left' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <h3 className="video-info-title" style={{ margin: 0, textAlign: 'left' }}>{video.title}</h3>
                    <span style={{
                      padding: '5px 12px',
                      background: 'rgba(255, 107, 53, 0.2)',
                      borderRadius: '15px',
                      fontSize: '0.85rem',
                      color: 'var(--primary-orange)',
                      fontWeight: '600',
                      whiteSpace: 'nowrap'
                    }}>
                      {video.category}
                    </span>
                  </div>
                  <p className="video-info-description" style={{ textAlign: 'left' }}>{video.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Modal Video */}
          {selectedVideo && (
            <div
              className="video-modal-overlay"
              onClick={closeVideoModal}
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
              }}
            >
              <div
                className="video-modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{
                  position: 'relative',
                  width: '90%',
                  maxWidth: '1200px',
                  backgroundColor: 'var(--primary-black)',
                  borderRadius: '15px',
                  padding: '20px'
                }}
              >
                <button
                  onClick={closeVideoModal}
                  style={{
                    position: 'absolute',
                    top: '-15px',
                    right: '-15px',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    border: 'none',
                    background: 'var(--primary-orange)',
                    color: 'white',
                    fontSize: '24px',
                    cursor: 'pointer',
                    zIndex: 1001
                  }}
                  aria-label="Fermer"
                >
                  ×
                </button>
                <div className="video-player-wrapper" style={{ position: 'relative', paddingTop: '56.25%' }}>
                  <iframe
                    src={`https://www.youtube.com/embed/${selectedVideo.youtubeId}?autoplay=1&rel=0`}
                    title={selectedVideo.title}
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          )}

          {/* No Results */}
          {filteredVideos.length === 0 && (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text-light)' }}>
              <h3 style={{ fontSize: '2rem', marginBottom: '15px' }}>ⵓⵔ ⵍⵍⵉⵏⵜ ⵜⵓⴳⴳⴰ ⴳ ⵢⵉⵙⵎⵉⵍ ⴰⴷ</h3>
              <p style={{ fontSize: '1.2rem' }}>ⴰⵔⵎ ⵢⴰⵏ ⵡⵉⵙⵎⵉⵍ ⵢⴰⴹⵏ ⵏⵖ ⵙⵜⵉ "ⴽⵓⵍⵍⵓ" ⵉ ⵓⵙⵎⴰⵍ ⵏ ⴽⵓⵍⵍⵓ ⵜⵓⴳⴳⴰ</p>
            </div>
          )}






    </div>
  </div>

  {/* Footer Note */}
  <div style={{
    background: 'var(--secondary-black)',
    padding: '30px 0',
    textAlign: 'center',
    borderTop: '1px solid rgba(255, 107, 53, 0.2)'
  }}>
  </div>
    <Carousel />
</div>
);
}

export default VideosAMZ;
